module.exports = __webpack_public_path__ + "img/hr-green-carpet-grass-02.cdf5a073.png";